export default __webpack_public_path__ + "static/media/avulsa.51e8c3e7.png";